import axios from "axios";

export const markupsMixin = {
    methods: {
        toggle(e) {
            let target = e.target;
            if (target.closest('[data-modal]')) {
                return;
            }
            if (target.closest('a')) {
                return;
            }
            if (!target.dataset.toogleMarkup) {
                target = target.closest('[data-toogle-markup]');
            }
            e.preventDefault();
            target.closest(target.dataset.toogleMarkup).classList.toggle('_open');
        },
        getColumnClasses(column) {
            return [`_${column.marketplaceKey}`, `_${column.sellerId}`];
        },
        objectToArray(obj) {
            if (obj) {
                return Object.values(obj.collection);
            }
        },
        rowSubmit(event) {
            const forms = Array.from(this.getEventTarget(event));
            this.sendForms(forms);
        },
        submit(event) {
            if (event.shiftKey) {
                return;
            }
            const form = event.target.closest('[data-mark-form]');
            if (form) {
                this.sendForms([form]);
            }
        },
        rowClear(event) {
            const forms = Array.from(this.getEventTarget(event));
            forms.forEach((form) => {
                form.querySelectorAll('input[type="number"]').forEach((inputEl) => {
                    inputEl.value = '';
                })
            });
        },
        sendForms(forms) {
            let promises = [];
            forms.forEach((form) => {
                const addData = this.getAdditionalData(form);
                const formData = new FormData(form);
                for (const key in addData) {
                    formData.append(key, addData[key]);
                }
                form.classList.add('_pending');
                promises.push(axios({
                    url: '/marketplace/dashbaord/markups/set/value',
                    method: 'post',
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" },
                }).then(response => {

                }).catch(response => {
                    this.toggleClassForm(form, '_error');
                }))
            });
            Promise.all(promises).then(() => {
                forms.forEach((form) => {
                    form.classList.remove('_pending');
                    this.toggleClassForm(form, '_success');
                })
            });
        },
        async sendOptionForm(event) {
            const form = event.target.closest('form');
            const addData = this.getAdditionalData(form);
            const formData = new FormData(form);
            for (const key in addData) {
                formData.append(key, addData[key]);
            }

            try {
                const response = await axios({
                    url: '/marketplace/dashbaord/markups/options/set',
                    method: 'post',
                    data: formData,
                    headers: {"Content-Type": "multipart/form-data"},
                });
                this.toggleClassForm(form, '_success');
            } catch (e) {
                alert('Ошибка при сохранении!');
                this.toggleClassForm(form, '_error');
            }
        },
        toggleClassForm(form, className) {
            form.classList.add(className);
            setTimeout(() => {
                form.classList.remove(className);
            }, 1000);
        },
        getEventTarget(event) {
            return event.target.closest('.m-k__row').querySelectorAll('[data-mark-form]');
        },
        getAdditionalData(form) {
            const data = {
                marketplace: form.dataset.marketplace,
                seller: form.dataset.seller,
                type: form.dataset.type,
            }
            if (form.dataset.producerId) {
                data.producer_id = form.dataset.producerId
            }
            if (form.dataset.modelId) {
                data.model_id = form.dataset.modelId
            }
            if (form.dataset.offerId) {
                data.offer_id = form.dataset.offerId
            }

            return data;
        }
    },
}